// Is a given variable undefined?
export default function isUndefined(obj) {
  return obj === void 0;
}



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.8@underscore/modules/isUndefined.js
// module id = 345
// module chunks = 115